import type Url from "../../ui-logic/ApiServices/Types/Url";
import type Query from "./Query";

export type RouterRule = (path: string, prev: string) => string;

/**
 * `keepSticky`: carry the sticky params of links (`diff`, `mode`, `view`, `oldScope`) over to the new address, for a
 * move to another article that should look like a link click. An explicit query wins; a path with its own `?query`
 * is left as is.
 */
export type PushPathOptions = { replace?: boolean; keepSticky?: boolean };
export type SetUrlOptions = { keepSticky?: boolean };

export abstract class Router {
	constructor(private _rules: RouterRule[]) {}

	abstract get basePath(): string;
	abstract get query(): Query;
	abstract get hash(): string;
	abstract get path(): string;

	static preventNextPushRefresh: boolean = false;

	getPreventNextPushRefresh() {
		return Router.preventNextPushRefresh;
	}

	setPreventNextPushRefresh(value: boolean) {
		Router.preventNextPushRefresh = value;
	}

	abstract pushQuery(query: Query): this;
	abstract pushPath(path: string, query?: Query, options?: PushPathOptions): Promise<void>;
	abstract setUrl(url: Url, options?: SetUrlOptions): this;

	protected _transform(path: string) {
		return this._rules.reduce(([prev, path], rule) => [path, rule(path, prev)], [this.path, path])[1];
	}
}
